<template>
  <div class="form__fields">
    <validation-provider
      rules="required"
      v-slot="{ errors }"
      class="form__group form__group--inline"
      v-for="(field, index1) in fields"
      :key="index1"
    >
      <label class="form__label form__label--inline">{{ field.label }}:</label>
      <div
        class="form__group"
        :class="{ 'form__group--error': errors.length > 0 }"
      >
        <input
          class="form__input"
          :type="field.type"
          v-model="addresses[index][field.column]"
          :placeholder="field.label"
          :disabled="!tab.editting"
        />
        <FormError :errors="errors" />
      </div>
    </validation-provider>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getterTypes } from "@/store/modules/Address/getter-types";
import { required } from "vee-validate/dist/rules";
import { ValidationProvider, extend } from "vee-validate";

extend("required", {
  ...required,
  message: "Pole jest wymagane...",
});

export default {
  name: "ShippingForm",
  props: {
    index: {
      type: Number,
    },
    tab: {
      type: Object,
    }
  },
  components: {
    FormError: () => import("@/pages/components/FormError"),
    ValidationProvider,
  },
  computed: {
    addresses() {
      return this.GET_ADDRESS();
    },
  },
  data() {
    return {
      loading: false,
      fields: [
        {
          label: "Imię",
          column: "firstName",
          type: "text",
        },
        {
          label: "Nazwisko",
          column: "lastName",
          type: "text",
        },
        {
          label: "Telefon",
          column: "phoneNumber",
          type: "text",
        },
        {
          label: "Ulica",
          column: "street",
          type: "text",
        },
        {
          label: "Kod pocztowy",
          column: "postcode",
          type: "text",
        },
        {
          label: "Miasto",
          column: "city",
          type: "text",
        },
        {
          label: "Firma",
          column: "company",
          type: "text",
        },
        {
          label: "Nazwa prowincji",
          column: "provinceName",
          type: "text",
        },
        {
          label: "Kod kraju",
          column: "countryCode",
          type: "text",
        },
      ],
    };
  },
  methods: {
    ...mapGetters("AddressModule", [getterTypes.GET_ADDRESS]),
  },
};
</script>